import { Button, Stack, Typography } from "@mui/material";
import { useRef } from "react";

// Campo de presskit en PDF, compartido por la ficha del roster y el perfil
// de un artista individual.
//
// `valor` es la URL del presskit ya guardado (o null), `archivo` el PDF
// recién elegido que todavía no se subió, y `quitar` la marca de que hay que
// borrar el existente. Los tres estados los maneja el formulario que lo usa;
// este componente solo los muestra y los cambia.
export default function CampoPresskit({
  valor,
  archivo,
  quitar,
  onElegir,
  onQuitar,
  onDeshacer,
  showSnack,
  maxMB = 10,
}) {
  const input = useRef(null);

  const elegir = (e) => {
    const file = e.target.files?.[0];
    // Se limpia el input para que volver a elegir el mismo archivo después
    // de un error dispare el onChange igual.
    e.target.value = "";
    if (!file) return;

    if (!file.name.toLowerCase().endsWith(".pdf")) {
      showSnack("El presskit debe ser un archivo PDF.", "warning");
      return;
    }
    if (file.size > maxMB * 1024 * 1024) {
      showSnack(`El presskit no puede pesar más de ${maxMB} MB.`, "warning");
      return;
    }

    onElegir(file);
  };

  const tieneGuardado = !!valor && !quitar;

  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        Presskit (PDF)
      </Typography>

      {archivo ? (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
            {archivo.name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            (se sube al guardar)
          </Typography>
          <Button size="small" onClick={() => onElegir(null)}>
            Quitar
          </Button>
        </Stack>
      ) : tieneGuardado ? (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Button
            size="small"
            href={valor}
            target="_blank"
            rel="noreferrer"
          >
            Descargar el actual
          </Button>
          <Button size="small" onClick={() => input.current?.click()}>
            Reemplazar
          </Button>
          <Button size="small" color="error" onClick={onQuitar}>
            Eliminar
          </Button>
        </Stack>
      ) : quitar ? (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Typography variant="body2" color="error">
            Se eliminará al guardar.
          </Typography>
          <Button size="small" onClick={onDeshacer}>
            Deshacer
          </Button>
        </Stack>
      ) : (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Button size="small" onClick={() => input.current?.click()}>
            Subir presskit
          </Button>
          <Typography variant="caption" color="text.secondary">
            PDF, hasta {maxMB} MB.
          </Typography>
        </Stack>
      )}

      <input
        ref={input}
        hidden
        type="file"
        accept="application/pdf,.pdf"
        onChange={elegir}
      />
    </Stack>
  );
}
